<template>
  <FiltersItemContent>
    <template #content>
      <div
        id="filter-slider-traveltime"
        class="filtersSlider"
      >
        <h5 class="filtersSlider__title">
          <span>{{ $l('showresult.filter.totalTimeTravelTitle') }}</span>
        </h5>
        <div class="filtersSlider__value">
          <span /><span id="slider-traveltime-text">{{ getSliderHeaderText }}</span>
        </div>
        <div class="sliderWrapper sliderWrapper--filter">
          <BaseSlider
            id="minMax-traveltime-slider"
            v-model:modelValue="sliderValues"
            :config="sliderConfig"
            @update="sliderUpdateEvent"
          />
        </div>
      </div>
    </template>
  </FiltersItemContent>
</template>


<script setup>
import { getTimeText, l } from '@js/utils/toolbox';

import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();


defineEmits(['update:filterObject']);

const uniqueMaxTraveltimePerTripLength = computed(() => resultQueryStore.state.response.uniqueMaxTraveltimePerTrip.length - 1);

const sliderValuesTranslated = ref(resultQueryStore.state.response.uniqueMaxTraveltimePerTrip[uniqueMaxTraveltimePerTripLength.value]);

const sliderConfig = ref({
	connect: [true, false],
	range: {
		min: 0,
		max: uniqueMaxTraveltimePerTripLength.value
	},
	handleAttributes: [
		{ 'aria-label': l('showresult.filter.totalTimeTravelTitle') }
	]
});

const sliderValues = computed({
	get: () => {
		const index = resultQueryStore.state.response.uniqueMaxTraveltimePerTrip.indexOf(filtersStore.state.traveltime);
		return index === -1 ? uniqueMaxTraveltimePerTripLength.value : index;
	},
	set: (values) => {
		const [start] = values;
		if (start === uniqueMaxTraveltimePerTripLength.value) {
			filtersStore.set({ key: 'traveltime', value: null });
			return;
		}
		sliderUpdateEvent(values);
		filtersStore.set({ key: 'traveltime', value: sliderValuesTranslated.value });
	}
});

const getSliderHeaderText = computed(() => {
	return getTimeText(sliderValuesTranslated.value);
});

const sliderUpdateEvent = (sliderValues) => {
	const [lowest] = sliderValues;
	sliderValuesTranslated.value = resultQueryStore.state.response.uniqueMaxTraveltimePerTrip[lowest];
};
</script>
